/* eslint-disable no-lonely-if */
/** *
 *  2022-8版本 不同系统的一些参数区分
 *
 */
import { isJSONString, setFavicon } from "@/utils/utils";

function hasYjbParameter() {
  // Check if the URL contains the 'yjb' parameter
  const queryString = window.location.search;
  if (queryString) {
      const params = new URLSearchParams(queryString);
      if (params.has('yjb')) {
          localStorage.setItem('yjb', '1');
          return true;
      }
  }

  // Check if localStorage contains 'yjb' with value '1'
  const yjbValue = localStorage.getItem('yjb');
  if (yjbValue === '1') {
      return true;
  }

  // If neither condition is met, return false
  return false;
}


// alert(hasYjbParameter());
const logoUi = [
  // 灵格低代码平台
  {
    hostname: "lowcode",
    imgSrc: require("@/assets/cy_img/linggekj_login_name@3x.png"),
    bgSrc: require("@/assets/images/linggekj_login_img@3x.png"),
    menuSrc: [
      {
        src: require("@/assets/cy_img/linggekj_name@3x.png"),
      },
      {
        src: require("@/assets/cy_img/linggekj_name@3x.png"),
      },
    ],
    menuHeight: null,
    test: "LOWCODE",
    menuTest: "LOWCODE",
    productRecommendUrl: '',
    appId: "90001",
    navigationBackColor: '#161D26', //导航背景色
    themeColor: '#4D4DFF', // 导航命中色&主题色
    navigationFoldColor: '#1F2935', // 导航折叠色
  },
  // 租户管理平台
  {
    hostname: "console",
    imgSrc: require("@/assets/cy_img/tenant_console_logo_name@3x.png"),
    bgSrc: require("@/assets/images/tenant_console_login_img@3x.png"),
    menuSrc: [
      {
        src: require("@/assets/cy_img/tenant_console_name@3x.png"),
      },
      {
        src: require("@/assets/cy_img/tenant_console_name@3x.png"),
      },
    ],
    menuHeight: null,
    test: "租户管理平台",
    menuTest: "租户管理平台",
    productRecommendUrl: '',
    appId: "70001",
    navigationBackColor: '#030937', //导航背景色
    themeColor: '#4D4DFF', // 导航命中色&主题色
    navigationFoldColor: '#161D26', // 导航折叠色
  },
  // 医装智能化采集分析平台
  {
      hostname: "equipment",
      imgSrc: require("@/assets/cy_img/equipment_logo_name@3x.png"),
      bgSrc: require("@/assets/images/equipment_login_img@3x.png"),
      menuSrc: [
        {
          src: require("@/assets/cy_img/equipment_name@3x.png"),
        },
        {
          src: require("@/assets/cy_img/equipment_name@3x.png"),
        },
      ],
      test: "",
      menuHeight: null,
      menuTest: "",
      productRecommendUrl: '',
      appId: "60001",
      navigationBackColor: '#05112C', //导航背景色
      themeColor: '#4D4DFF', // 导航命中色&主题色
      navigationFoldColor: '#0A0E86', // 导航折叠色
    },
    // 英比翼一体机平台
    {
        hostname: "allinones",
        imgSrc: require("@/assets/cy_img/yingbiyi_name@3x.png"),
        bgSrc: require("@/assets/images/linggekj_login_img@3x.png"),
        menuSrc: [
          {
            src: require("@/assets/cy_img/yingbiyi_name@3x.png"),
          },
          {
            src: require("@/assets/cy_img/yingbiyi_name@3x.png"),
          },
        ],
        menuHeight: null,
        test: "英比翼一体机",
        menuTest: "英比翼一体机",
        productRecommendUrl: '',
        appId: "50001",
        navigationBackColor: '#161D26', //导航背景色
        themeColor: '#4D4DFF', // 导航命中色&主题色
        navigationFoldColor: '#1F2935', // 导航折叠色
      },
      // 灵播Live平台
      {
        hostname: "lingbolive",
        imgSrc: require("@/assets/cy_img/lingbolive_name@3xnew.png"),
        bgSrc:  "https://cdn1.lingbo.tv/web_images/lingbolive_login_img@3x.9045225c.png",
        menuSrc: [
          {
            src: require("@/assets/cy_img/xxxxx.png"),
          },
          {
            src: require("@/assets/cy_img/xxxxx.png"),
          },
        ],
        test: "",
        menuHeight: '46px',
        menuTest: "",
        productRecommendUrl: '',
        appId: "100001",
        navigationBackColor: '#161D26', //导航背景色
        themeColor: '#4D4DFF', // 导航命中色&主题色
        navigationFoldColor: '#1F2935', // 导航折叠色
      },
      // 灵播Live平台
      {
        hostname: "admin",
        imgSrc: require("@/assets/cy_img/lingbolive_name@3xnew.png"),
        bgSrc:  "https://cdn1.lingbo.tv/web_images/lingbolive_login_img@3x.9045225c.png",
        menuSrc: [
          {
            src: require("@/assets/cy_img/xxxxx.png"),
          },
          {
            src: require("@/assets/cy_img/xxxxx.png"),
          },
        ],
        test: "",
        menuHeight: '46px',
        menuTest: "",
        productRecommendUrl: '',
        appId: "100001",
        navigationBackColor: '#161D26', //导航背景色
        themeColor: '#4D4DFF', // 导航命中色&主题色
        navigationFoldColor: '#1F2935', // 导航折叠色
      },
      {
        hostname: "manager",
        imgSrc: require("@/assets/cy_img/lingbolive_name@3xnew.png"),
        bgSrc:  "https://cdn1.lingbo.tv/web_images/lingbolive_login_img@3x.9045225c.png",
        menuSrc: [
          {
            src: require("@/assets/cy_img/xxxxx.png"),
          },
          {
            src: require("@/assets/cy_img/xxxxx.png"),
          },
        ],
        test: "",
        menuHeight: '46px',
        menuTest: "",
        productRecommendUrl: '',
        appId: "100001",
        navigationBackColor: '#161D26', //导航背景色
        themeColor: '#4D4DFF', // 导航命中色&主题色
        navigationFoldColor: '#1F2935', // 导航折叠色
   },
  {
    hostname: "workflow",
    imgSrc: require("@/assets/cy_img/linggekj_login_name@3x.png"),
    bgSrc: require("@/assets/images/linggekj_login_img@3x.png"),
    menuSrc: [
      {
        src: require("@/assets/cy_img/linggekj_name@3x.png"),
      },
      {
        src: require("@/assets/cy_img/linggekj_logo@3x.png"),
      },
    ],
    test: "审批",
    menuHeight: null,
    menuTest: "审批",
    productRecommendUrl: '',
    appId: "99999",
    navigationBackColor: '#161D26', //导航背景色
    themeColor: '#4D4DFF', // 导航命中色&主题色
    navigationFoldColor: '#1F2935', // 导航折叠色
  },
];

const getRepeat = () => {
  return logoUi.find((el) => {
    if (window.location.hostname.toString().includes(el.hostname)) {
      return el;
    }
  });
};
const getLogo = () => {
  // 判断当前域名
  let hostList;
  hostList = getRepeat();
  if (isJSONString("uiInfo") && process.env.NODE_ENV !== 'development') {
    const uiInfo = JSON.parse(localStorage.getItem("uiInfo")) || {};
    const uiFitment = JSON.parse(localStorage.getItem("ui_fitment")) || {};
    // eslint-disable-next-line no-inner-declarations
    function endowValue(a, b) {
      if(uiInfo[b]){
        hostList[a] = uiInfo[b];
      }
    }
    const keys = [
       {
         hostLisKey: "menuTest",
         uiInfoKey: "appHomeTitle", // 主页显示名称
       },
      {
        hostLisKey: "test",
        uiInfoKey: "appLoginName", // 登录页显示名称
      },
      {
        hostLisKey: "imgSrc",
        uiInfoKey: "appLoginLogo", // 登录页显示logo
      },
      {
        hostLisKey: "bgSrc",
        uiInfoKey: "appLoginBackPic", // 登录页显示背景图
      },
      {
        hostLisKey: 'productRecommendUrl',
        uiInfoKey: "productRecommendUrl", // 关于我们
      }
    ];
    keys.forEach((m) => {
      endowValue(m.hostLisKey, m.uiInfoKey);
    });
    if(uiFitment.menuLogo || uiInfo.appHomeLogo) {
      hostList.menuSrc[0].src = uiFitment.menuLogo || uiInfo.appHomeLogo;
    }
    if(uiFitment.menuLogoSmall || uiInfo.appHomeLogoSmall) {
      hostList.menuSrc[1].src = uiFitment.menuLogoSmall || uiInfo.appHomeLogoSmall
    }
    if(uiFitment.menuTitle || uiInfo.appHomeTitle) {
      hostList.menuTest = uiFitment.menuTitle || uiInfo.appHomeTitle
    }
    hostList.navigationBackColor = uiFitment.navigationBackColor || '#161D26';
    hostList.themeColor = uiFitment.themeColor || '#4D4DFF';
    hostList.navigationFoldColor = uiFitment.navigationFoldColor || '#1F2935';
    let _ico = uiFitment.browserIco? uiFitment.browserIco: (uiInfo.appHomeIcon || '');
    if(_ico) {
      setFavicon(_ico);
    }
    if (uiFitment.homeTitle) {
      document.title = uiFitment.homeTitle;
    }
  }else {
    if (!hostList) {
      hostList = {
        hostname: undefined,
        imgSrc: require("@/assets/images/linggekj_login_name@3x.png"),
        bgSrc: require("@/assets/images/linggekj_login_img@3x.png"),
        menuSrc: [
          {
            src: require("@/assets/images/linggekj_name@3x.png"),
          },
          {
            src: require("@/assets/images/linggekj_name@3x.png"),
          },
        ],
        test: "",
        menuTest: "低代码平台",
        productRecommendUrl: '',
        appId: undefined,
        navigationBackColor: '#161D26', //导航背景色
        themeColor: '#4D4DFF', // 导航命中色&主题色
        navigationFoldColor: '#1F2935', // 导航折叠色
      };
    }
  }

  return hostList;
};

export {
  // eslint-disable-next-line import/prefer-default-export
  getLogo,
  hasYjbParameter
};
